// extracted by mini-css-extract-plugin
module.exports = {"root":"PaginationSize_root__sruB4","dropdown":"PaginationSize_dropdown__3869s","dropdownItem":"PaginationSize_dropdownItem__1nSnz"};